export const ARTISTS_STATES = [
    {
        code: 'DRAFT',
        name: 'state.default.code.draft'
    }, {
        code: 'PENDING',
        name: 'state.default.code.pending'
    }, {
        code: 'PUBLISHED',
        name: 'state.default.code.published'
    }, {
        code: 'REJECTED',
        name: 'state.default.code.rejected'
    }, {
        code: 'BLOCKED',
        name: 'state.default.code.blocked'
    }, {
        code: 'ARCHIVE',
        name: 'state.default.code.archive'
    }
]
